<div class="container">
    <p-table (onRowSelect)="onRowSelect($event)" [(selection)]="selectedIProduct" [autoLayout]="true" [value]="products"
             styleClass="p-datatable-sm">
        <ng-template *ngIf="addButton" pTemplate="header">
            <tr>
                <th *ngIf="addRadio" style="width: 3rem"></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>
                    <button (click)="openModal()" *ngIf="addButton" icon="pi pi-plus" pButton style="float:right;"
                            type="button"></button>
                </th>
            </tr>
        </ng-template>
        <ng-template let-product pTemplate="body">
            <tr>
                <td *ngIf="addRadio">
                    <p-tableRadioButton [value]="product"></p-tableRadioButton>
                </td>
                <td>
                    <p-avatar [image]="product.imageUrl" size="large"></p-avatar>
                </td>
                <td>
                    <div>{{product.name}}</div>
                    <div *ngIf="!priceColumn && product.basePrice && product.sellingPrice">
                        <s>{{product.basePrice | currency:'THB':'code'}}</s>&nbsp;
                        {{product.sellingPrice | currency:'THB':'code'}}
                    </div>
                    <div *ngIf="!priceColumn && product.basePrice && !product.sellingPrice">
                        {{product.basePrice | currency:'THB':'code'}}
                    </div>
                </td>
                <td *ngIf="priceColumn && product.basePrice && product.sellingPrice">
                    <s>{{product.basePrice | currency:'THB':'code'}}</s>
                </td>
                <td *ngIf="priceColumn && product.basePrice && !product.sellingPrice">
                    {{product.basePrice | currency:'THB':'code'}}
                </td>
                <td>
                    <div *ngIf="priceColumn && product.basePrice && product.sellingPrice">
                        {{product.sellingPrice | currency:'THB':'code'}}
                    </div>
                </td>
                <td>
                    <div *ngIf="deleteColumn">
                        <button (click)="removeProduct(product)" class="p-button-danger" icon="pi pi-times" pButton
                                pRipple
                                style="float:right;" type="button"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog (onHide)="onHide()" [(visible)]="displayModal" [baseZIndex]="10000" [draggable]="false"
              [modal]="true"
              [resizable]="false" [style]="{width: '60vw'}">
        <ng-template pTemplate="header">
            <div class="p-col-12 p-md-4">
                <div class="p-inputgroup">
                    <input [(ngModel)]="searchProductKeyword" pInputText placeholder="Search" type="text">
                    <button (click)="search()" icon="pi pi-search" pButton pRipple styleClass="p-button-warn"
                            type="button"></button>
                </div>
            </div>
            <jhi-category-auto-complete
                    (selectedCategoriesOutput)="setCategory($event)"
                    (unSelectedCategoriesOutput)="removeCategory($event)"
                    [filterByGroup]="'PRODUCT'"
                    [language]="'en'"
                    [multiple]="true"
                    [room]="room"
                    [selectedCategories]="selectedCatagories"
                    id="field_category"
                    name="category">
            </jhi-category-auto-complete>
        </ng-template>
        <p-table [autoLayout]="true" [rows]="20"
                 [value]="searchedProducts"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 styleClass="p-datatable-sm">
            <ng-template let-product pTemplate="body">
                <tr>
                    <td>
                        <p-avatar [image]="product.imageUrl" size="large"></p-avatar>
                    </td>
                    <td>
                        <div>{{product.name}}</div>
                        <div *ngIf="!priceColumn && product.basePrice && product.sellingPrice">
                            <s>{{product.basePrice | currency:'THB':'code'}}</s>&nbsp;
                            {{product.sellingPrice | currency:'THB':'code'}}
                        </div>
                        <div *ngIf="!priceColumn && product.basePrice && !product.sellingPrice">
                            {{product.basePrice | currency:'THB':'code'}}
                        </div>
                    </td>
                    <td *ngIf="priceColumn && product.basePrice && product.sellingPrice">
                        <s>{{product.basePrice | currency:'THB':'code'}}</s>
                    </td>
                    <td *ngIf="priceColumn && product.basePrice && !product.sellingPrice">
                        {{product.basePrice | currency:'THB':'code'}}
                    </td>
                    <td *ngIf="priceColumn && !product.basePrice">
                        {{0 | currency:'THB':'code'}}
                    </td>
                    <td>
                        <div *ngIf="priceColumn && product.basePrice && product.sellingPrice">
                            {{product.sellingPrice | currency:'THB':'code'}}
                        </div>
                    </td>
                    <td>
                        <p-checkbox (click)="toggleProduct(product)" [binary]="true"
                                    [ngModel]="isSelected(product.id)"></p-checkbox>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <p-paginator (onPageChange)="loadProducts($event)" *ngIf="searchedProducts && searchedProducts.length > 0"
                     [rowsPerPageOptions]="[5,10,20,30]" [rows]="itemPerPage" [showCurrentPageReport]="true"
                     [totalRecords]="totalRecords"
                     currentPageReportTemplate="Showing {first} - {last} of {totalRecords} items.">

        </p-paginator>
        <p-tag *ngFor="let item of selectedProducts; index as i" [value]="item.name" severity="info"></p-tag>
        <ng-template pTemplate="footer">
            <p-button (click)="displayModal=false" (onClick)="addProduct()" [disabled]="selectedProducts.length === 0"
                      icon="pi pi-plus"
                      label="Add" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>
